import { createRouter, createWebHistory } from 'vue-router';
import { getToken } from "@/utils"

export const routes = [
  {
    path: '/',
    name: "/",
    component: () => import('@/views/index.vue'),
    children: []
  }, {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
  }, {
    path: '/signup',
    name: 'Signup',
    component: () => import('@/views/login/signup.vue'),
  }, {
    path: '/coin',
    name: 'Coin',
    component: () => import('@/views/coin/index.vue'),
  }, {
    path: '/micro',
    name: 'Micro',
    component: () => import('@/views/contract/micro.vue'),
  }, {
    path: '/lever',
    name: 'Lever',
    component: () => import('@/views/contract/lever.vue'),
  }, {
    path: '/forex',
    name: 'Forex',
    component: () => import('@/views/forex/index.vue'),
  }, {
    path: '/loan',
    name: 'Loan',
    component: () => import('@/views/loan/index.vue'),
  }, {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('@/views/bank/recharge.vue'),
  }, {
    path: '/qrcode/:item',
    name: 'Qrcode',
    component: () => import('@/views/bank/recharge_qrimg.vue'),
  }, {
    path: '/assets',
    component: () => import('@/views/assets/index.vue'),
    redirect: '/assets/detail',
    children: [{
      path: 'detail',
      name: 'AssetsDetail',
      component: () => import('@/views/assets/detail.vue'),
      meta: {
        img: require('@/assets/assets/assets.png'),
        selectImg: require('@/assets/assets/assets_select.png'),
        title: '我的资产'
      }
    }, {
      path: 'certification',
      name: 'AssetsCertification',
      component: () => import('@/views/assets/certification.vue'),
      meta: {
        img: require('@/assets/assets/certification.png'),
        selectImg: require('@/assets/assets/certification_select.png'),
        title: '身份认证'
      }
    }, {
      path: 'recharge_order',
      name: 'AssetsRechargeOrder',
      component: () => import('@/views/assets/recharge_order.vue'),
      meta: {
        img: require('@/assets/assets/recharge_order.png'),
        selectImg: require('@/assets/assets/recharge_order_select.png'),
        title: '充值记录'
      }
    }, {
      path: 'withdraw',
      name: 'AssetsWithdraw',
      component: () => import('@/views/assets/withdraw.vue'),
      meta: {
        img: require('@/assets/assets/withdraw.png'),
        selectImg: require('@/assets/assets/withdraw_select.png'),
        title: '提款'
      }
    }, {
      path: 'withdraw_order',
      name: 'AssetsWithdrawOrder',
      component: () => import('@/views/assets/withdraw_order.vue'),
      meta: {
        img: require('@/assets/assets/withdraw_order.png'),
        selectImg: require('@/assets/assets/withdraw_order_select.png'),
        title: '提款记录'
      }
    }, {
      path: 'bank_address',
      name: 'AssetsBankAddress',
      component: () => import('@/views/assets/bank_address.vue'),
      meta: {
        img: require('@/assets/assets/address.png'),
        selectImg: require('@/assets/assets/address_select.png'),
        title: '提款地址'
      }
    }]
  }, {
    path: '/user',
    component: () => import('@/views/user/index.vue'),
    redirect: '/user/info',
    children: [{
      path: 'info',
      name: 'UserInfo',
      component: () => import('@/views/user/info.vue'),
      meta: {
        img: '',
        selectImg: '',
        title: '账号设定'
      }
    }, {
      path: 'about/:type',
      name: 'UserAbout',
      component: () => import('@/views/user/about.vue'),
      meta: {
        img: '',
        selectImg: '',
        title: '白皮书'
      }
    },{
      path: 'message',
      name: 'UserMessage',
      component: () => import('@/views/user/message.vue'),
      meta: {
        img: '',
        selectImg: '',
        title: '通知'
      }
    }]
  },{
    path: '/user/message_detail/:id',
    name: 'MessageDetail',
    component: () => import('@/views/user/message_detail.vue'),
  }, {
    path: '/user/login_password',
    name: 'LoginPasword',
    component: () => import('@/views/user/login_password.vue'),
  }, {
    path: '/user/trade_password',
    name: 'tradePasword',
    component: () => import('@/views/user/trade_password.vue'),
  }, {
    path: '/mining',
    name: 'Mining',
    component: () => import('@/views/mining/index.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = getToken();
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router;